import { useEffect, useRef } from 'react';
import styles from './HostCampaignPage.module.css';

export function HostCampaignVideo() {
  const video = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    function applyPreference() {
      if (video.current) video.current.autoplay = !preference.matches;
      if (preference.matches) video.current?.pause();
      else void video.current?.play().catch(() => { /* Keep the poster if the browser blocks background playback. */ });
    }
    applyPreference();
    preference.addEventListener('change', applyPreference);
    return () => preference.removeEventListener('change', applyPreference);
  }, []);
  return <video ref={video} className={styles.heroVideo}
    src="https://evinitiative.com/media/film-building.mp4"
    poster="https://evinitiative.com/media/film-building-poster.jpg"
    aria-hidden="true" tabIndex={-1} disablePictureInPicture
    width={1600} height={900} muted loop playsInline preload="metadata" />;
}
